import React, {Component} from 'react';
import compose from 'recompose/compose';
import {connect} from 'react-redux';
import {withStyles} from '@material-ui/core/styles';
import classNames from 'classnames';
import moment from 'moment';
import _ from 'lodash';
import {
	changeCurrentPath,
	undoReceiptFlag,
	resetReceiptListState,
	fetchReceiptList,
	getPdfItemsReceipt,
	getPdfItemsReceiptMod,
	clearPdfItemsReceipt,
	clearPdfItemsReceiptMod,
	fetchCsvDataReceipt,
	getPdfItemsReceiptSecom,
	clearPdfItemsReceiptSecom, getReceiptArrivalPdf, clearPdfItemsReceiptArrival
} from '../../actions';

import Header from '../../common/containers/header';
import Progress from '../../common/containers/progress'
import SpNav from '../../common/containers/sp_nav'
import Footer from '../../common/containers/footer';

import ErrorDialog from '../../common/components/dialog/error-dialog';
import ReloadModal from '../../common/components/dialog/reload-dialog';
import LogoutModal from '../../common/components/dialog/logout-dialog';
import Tables from '../../common/components/table/common-table';

import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelActions from '@material-ui/core/ExpansionPanelActions';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';

import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormGroup from '@material-ui/core/FormGroup';
import Button from '@material-ui/core/Button';

import Checkbox from '@material-ui/core/Checkbox';


import {DatePicker} from 'material-ui-pickers';
import PdfViewer from '../../common/components/viewer/pdf-viewer';
import AlertDialog from '../../common/components/dialog/alert-dialog';
import MainButtons from "../../common/components/main-buttons";

const columns = [
	{name: 'NiukeshoStatusName', title: 'ステータス', width: 150},
	{name: 'NinushiTorihikiName', title: '取引名称', width: 100},
	{name: 'NohinYoteiYMD', title: '納品日', width: 135},
	{name: 'OtodokesakiName', title: '納品先名称', width: 200},
	{name: 'OtodokesakiAddress', title: '納品先住所', width: 400},
	{name: 'NinushiName', title: '荷主名', width: 200},
	{name: 'DenpyoNO', title: '伝票番号', width: 150},
	{name: 'Receipts', title: '納品書', width: 120, sortingEnabled: false, filteringEnabled: false},
	{name: 'CorrectionStatusName', title: '訂正', width: 120},
];

const numberColumns = ['TorikomiCount', 'DenpyoMaisu'];


const styles = theme => ({
	datePicker: {
		marginTop: '-7px',
		width: '150px'
	},
	fromTo: {
		padding: '0 15px',
		fontSize: '1.5rem',
		fontFamily: "Roboto, Helvetica, Arial, sans-serif",
	},
	heading: {
		fontSize: theme.typography.pxToRem(15),
		fontFamily: 'Noto Sans JP'
	},
	expands: {
		boxShadow: 'initial'
	},
	ExpansionPanelDetails: {
		flexDirection: 'column'
	},
	ExpansionPanelDetailsRow: {
		alignItems: 'center'
	},
	ExpansionPanelDetailsRowTitle: {
		color: 'rgba(0,0,0,0.54)',
		paddingRight: 20,
	},
	ExpansionPanelDetailsRowTitleSecond: {
		borderLeft: 'rgba(0,0,0,0.3) solid 1px',
		paddingLeft: 20

	}
});

const flg = [
	1 << 0
	, 1 << 1
	, 1 << 2
];

const DLMaxCount = 5000;

class ReceiptList extends Component {

	constructor(props) {
		super(props);
		const correctionStatus = flg[0] | flg[1];
		const receiptStatus = flg[0] | flg[1] | flg[2];

		this.state = {
			rows: [],
			dateType: props.settings.dateType,
			selectedDateFrom: props.settings.selectedDateFrom,
			selectedDateTo: props.settings.selectedDateTo,
			selections: props.settings.selections,
			sorts: props.settings.sorts,
			dialogOpenUndo: false,
			undoRow: {},
			receiptPdfUrl: null,
			dlErrorOpen: false,
			correctionStatus,
			receiptStatus,
			selectionDetailCount: 0,
			showDlErrorDialog: false,
		};
		this.nextIsUpload = false;
	}

	/** override methods **/
	UNSAFE_componentWillMount() {
		this.handleClickSumup();
	}

	componentDidMount() {
		const {dispatch, history} = this.props;
		window.scrollTo(0, 0);
		dispatch(changeCurrentPath({currentPath: history.location.pathname}));
	}

	componentWillUnmount() {
		const {dispatch} = this.props;
		dispatch(resetReceiptListState());
	}


	/** event handlers **/
	handleDateTypeChange = event => {
		this.setState({dateType: event.target.value});
	};
	handleDateFromChange = date => {
		let selectedDateTo = this.state.selectedDateTo;
		if (selectedDateTo) {
			const dateDiff = selectedDateTo.diff(date, 'days');
			if (dateDiff < 0) {
				selectedDateTo = new moment(date);
			} else if (dateDiff > 90) {
				selectedDateTo = new moment(date);
				selectedDateTo.add(90, 'days');
			}
		}
		this.setState({
			selectedDateFrom: date,
			selectedDateTo
		});
	};
	handleDateFromInputChange = (e) => {
		if (!e.target.value) this.setState({selectedDateFrom: null});
	};
	handleDateToChange = date => {
		let selectedDateFrom = this.state.selectedDateFrom;
		if (selectedDateFrom) {
			const dateDiff = date.diff(selectedDateFrom, 'days');
			if (dateDiff < 0) {
				selectedDateFrom = new moment(date);
			} else if (dateDiff > 90) {
				selectedDateFrom = new moment(date);
				selectedDateFrom.add(-90, 'days');
			}
		}
		this.setState({
			selectedDateFrom,
			selectedDateTo: date
		});
	};
	handleDateToInputChange = (e) => {
		if (!e.target.value) this.setState({selectedDateTo: null});
	};

	handleSelectionChange = selections => {

		let selectionDetailCount = 0;
		selections.forEach((row) => {
			selectionDetailCount += isNaN(row.DetailCount) ? 0 : Number(row.DetailCount);
		});
		this.setState({
			selections,
			selectionDetailCount
		});

	};
	handleSortOrderChange = (sorts) => {
		this.setState({
			sorts
		});
	};
	handleClickSumup = event => {
		const {dispatch} = this.props;
		const {dateType, selectedDateFrom, selectedDateTo, receiptStatus, correctionStatus} = this.state;
		this.setState({
			selections: []
		});
		dispatch(fetchReceiptList({
			dateType,
			selectedDateFrom: !(selectedDateFrom) ? null : moment(selectedDateFrom).format('YYYY-MM-DD'),
			selectedDateTo: !(selectedDateTo) ? null : moment(selectedDateTo).format('YYYY-MM-DD'),
			receiptStatus,
			correctionStatus,
			SessionID: this.props.auth.SessionID
		}));
	};

	handleClickDL = event => {

		if (this.state.selectionDetailCount > DLMaxCount) {
			this.setState({
				showDlErrorDialog: true
			});
			return;
		}

		const {dispatch} = this.props;
		const selections = this.state.selections.map(selection => {
			return selection["id"];
		});
		dispatch(fetchCsvDataReceipt({
			selections,
			SessionID: this.props.auth.SessionID
		}));
	};

	handleClickSlipNo = (row) => {
		const {dispatch, auth} = this.props;
		const selections = [row["id"]];
		dispatch(getPdfItemsReceipt({
			selections,
			SessionID: auth.SessionID
		}));
	};
	handleClickReceiptSlip = (row) => {
		if (row.HasSecomPdf) {
			const selections = [row["id"]];
			this.props.dispatch(getPdfItemsReceiptSecom({
				selections,
				SessionID: this.props.auth.SessionID,
				UploadAreaCD: row.UploadAreaCD,
				UploadFileName: row.UploadFileName,
				UploadDirectoryNO: row.UploadDirectoryNO,
				ReceiptPdfPath: row.ReceiptPdfPath,
			}));
		} else if (row.ReceiptPdfPath) {
			this.setState({
				receiptPdfUrl: row.ReceiptPdfPath
			});
		} else if (row.ReceiptSignPath) {
			const selections = [row["id"]];
			this.props.dispatch(getPdfItemsReceiptMod({
				selections,
				SessionID: this.props.auth.SessionID
			}));
		} else {
			this.setState({
				receiptPdfUrl: row.UploadPdfPath
			});
		}

	};
	handleClickArrivalPdf = () => {
		if (this.state.selectionDetailCount > DLMaxCount) {
			this.setState({
				showDlErrorDialog: true
			});
			return;
		}

		const {dispatch} = this.props;
		const selections = this.state.selections.map(selection => {
			return selection["id"];
		});
		dispatch(getReceiptArrivalPdf({
			selections,
			SessionID: this.props.auth.SessionID
		}));
	}

	afterCloseFunc = () => {
		const {dispatch} = this.props;
		dispatch(clearPdfItemsReceipt());
	};

	afterCloseModFunc = () => {
		const {dispatch} = this.props;
		dispatch(clearPdfItemsReceiptMod());
	};

	afterCloseSecomFunc = () => {
		const {dispatch} = this.props;
		dispatch(clearPdfItemsReceiptSecom());
	}

	afterCloseFuncReceiptSlips = () => {
		this.setState({
			receiptPdfUrl: null
		});
	};

	afterCloseArrivalFunc = () => {
		const {dispatch} = this.props;
		dispatch(clearPdfItemsReceiptArrival());
	}

	handleClickUndo = (row) => {
		this.setState({
			dialogOpenUndo: true,
			undoRow: row
		});
	};

	doUndo = () => {
		this.setState({
			dialogOpenUndo: false
		});
		const {dispatch, auth} = this.props;
		const {dateType, selectedDateFrom, selectedDateTo, receiptStatus, correctionStatus} = this.state;
		dispatch(undoReceiptFlag({
			dateType,
			selectedDateFrom: !(selectedDateFrom) ? null : moment(selectedDateFrom).format('YYYY-MM-DD'),
			selectedDateTo: !(selectedDateTo) ? null : moment(selectedDateTo).format('YYYY-MM-DD'),
			receiptStatus,
			correctionStatus,
			SessionID: auth.SessionID,
			id: this.state.undoRow.id
		}));
	};

	cancelUndo = () => {
		this.setState({
			dialogOpenUndo: false
		});
	};


	handleCheckChangeReceipt = (e) => {
		let receiptStatus = this.state.receiptStatus;
		receiptStatus ^= flg[parseInt(e.target.value, 10)];
		this.setState({
			receiptStatus
		});
	};


	handleCheckChangeCorrect = (e) => {
		let correctionStatus = this.state.correctionStatus;
		correctionStatus ^= flg[parseInt(e.target.value, 10)];
		this.setState({
			correctionStatus
		});
	};

	handleCloseDlError = () => {
		this.setState({
			showDlErrorDialog: false
		});
	};

	render() {
		const {classes, settings, auth} = this.props;
		const {
			dateType, selectedDateFrom, selectedDateTo, dialogOpenUndo, receiptPdfUrl,
			correctionStatus, selections, sorts, selectionDetailCount, showDlErrorDialog
		} = this.state;

		const rows = settings.data;
		const disabled = !(selections.length);

		const Registered = _.filter(rows, (row) => {
			return row.isSelectionReplace === "1"
		});
		const mainButtons = [
			{type: 'DL', func: this.handleClickDL, disabled: disabled}
		];
		console.log(auth.user)
		if (auth.user.IsReceiptArrivalPdfOptionAvailable) {
			mainButtons.push({type: 'PRINT', func: this.handleClickArrivalPdf, disabled: disabled, text: '帳票出力'})
		}

		const limitText = <span>対象データが大きいため、期間や荷主などでデータを絞り込んで下さい<br/>
			<br/>
			現在の選択件数 : {selectionDetailCount}<br/>
			※同時DL可能上限 : {DLMaxCount}件(明細数)</span>;

		const clickableColumns = [
			{name: 'DenpyoNO', func: this.handleClickSlipNo},
			{
				name: 'Receipts',
				func: this.handleClickReceiptSlip,
				type: 'button',
				text: '表示',
				visibleKeyColumn: 'HasReceiptSlips'
			},
			{name: 'SelectionReplaceButton', func: this.handleClickUndo, type: 'button', text: '取消'}
		];

		const printDialogOpen = (settings.pdfPath !== undefined);
		const printDialogModOpen = (settings.pdfPathMod !== undefined);
		const printDialogSecomOpen = (settings.pdfPathSecom !== undefined);
		const printDialogArrivalOpen = (settings.receiptArrivalPdfPath !== undefined);


		/*
		const checkedStateReceipt = [0,1,2].map((value)=>{
			return (receiptStatus & flg[value]) === flg[value];
		});
		*/

		const checkedStateCorrect = [0, 1].map((value) => {
			return (correctionStatus & flg[value]) === flg[value];
		});

		return (
			<div id="main_container">
				{settings.isFetching &&
				<Progress/>
				}
				<SpNav history={this.props.history}/>
				<Header history={this.props.history}/>
				<article>
					<section className="title_area">
						<h2>電子受領</h2>
					</section>
					<ExpansionPanel defaultExpanded
									className={classNames("with_button condition_area", classes.expands)}>
						<ExpansionPanelSummary expandIcon={<ExpandMoreIcon/>} className={classes.summary}>
							<Typography className={classes.heading}>抽出条件</Typography>
						</ExpansionPanelSummary>
						<ExpansionPanelDetails className={classes.ExpansionPanelDetails}>
							<FormGroup row>
								<RadioGroup
									aria-label="gender"
									name="gender2"
									value={dateType}
									onChange={this.handleDateTypeChange}
									row
								>
									<FormControlLabel
										value="0"
										control={<Radio/>}
										label="出荷日"

									/>
									<FormControlLabel
										value="1"
										control={<Radio/>}
										label="納品日"
									/>
									<FormControlLabel
										value="2"
										control={<Radio/>}
										label="伝票日付"

									/>
									<FormControlLabel
										value="3"
										control={<Radio/>}
										label="取込日"
									/>
								</RadioGroup>
								<DatePicker
									keyboard
									label="開始"
									minDateMessage={"7年前までの日付を入力"}
									maxDateMessage={"10日後までの日付を入力"}
									minDate={new moment().add(-7, 'years')}
									maxDate={new moment().add(10, 'days')}
									value={selectedDateFrom}
									onChange={this.handleDateFromChange}
									onInputChange={this.handleDateFromInputChange}
									format="YYYY/MM/DD"
									className={classes.datePicker}
									invalidDateMessage="日付が正しくありません"
									cancelLabel={"キャンセル"}

								/>
								<div className={classes.fromTo}>-</div>
								<DatePicker
									keyboard
									label="終了"
									minDateMessage={"7年前までの日付を入力"}
									maxDateMessage={"10日後までの日付を入力"}
									minDate={new moment().add(-7, 'years')}
									maxDate={new moment().add(10, 'days')}
									value={selectedDateTo}
									onChange={this.handleDateToChange}
									onInputChange={this.handleDateToInputChange}
									className={classes.datePicker}
									format="YYYY/MM/DD"
									invalidDateMessage="日付が正しくありません"
									cancelLabel={"キャンセル"}

								/>

							</FormGroup>
							<FormGroup row className={classes.ExpansionPanelDetailsRow}>
								{/*
								<div className={classes.ExpansionPanelDetailsRowTitle}>
									ステータス条件
								</div>
								<FormControlLabel
									control={
										<Checkbox
											checked={checkedStateReceipt[0]}
											onChange={this.handleCheckChangeReceipt}
											value={"0"}
											color="primary"
										/>
									}
									label="納品済"
								/>
								<FormControlLabel
									control={
										<Checkbox
											checked={checkedStateReceipt[1]}
											onChange={this.handleCheckChangeReceipt}
											value={"1"}
											color="primary"
										/>
									}
									label="(空白)"
								/>
								<FormControlLabel
									control={
										<Checkbox
											checked={checkedStateReceipt[2]}
											onChange={this.handleCheckChangeReceipt}
											value={"2"}
											color="primary"
										/>
									}
									label="未印刷"
								/>
								<div className={classNames(classes.ExpansionPanelDetailsRowTitle,classes.ExpansionPanelDetailsRowTitleSecond)}>
									訂正有無
								</div>
								*/}
								<div className={classNames(classes.ExpansionPanelDetailsRowTitle)}>
									訂正有無
								</div>
								<FormControlLabel
									control={
										<Checkbox
											checked={checkedStateCorrect[0]}
											onChange={this.handleCheckChangeCorrect}
											value={"0"}
											color="primary"
										/>
									}
									label="有"
								/>
								<FormControlLabel
									control={
										<Checkbox
											checked={checkedStateCorrect[1]}
											onChange={this.handleCheckChangeCorrect}
											value={"1"}
											color="primary"
										/>
									}
									label="無"
								/>
							</FormGroup>
						</ExpansionPanelDetails>
						<Divider/>
						<ExpansionPanelActions>
							<Button variant="contained" color="primary" size="large" onClick={this.handleClickSumup}>
								集計
							</Button>
						</ExpansionPanelActions>
					</ExpansionPanel>
					<section className="with_button">
						<Tables
							dataSource={rows}
							columns={columns}
							numberColumns={numberColumns}
							clickableColumns={clickableColumns}
							getSelections={this.handleSelectionChange}
							getSortOrders={this.handleSortOrderChange}
							defaultSorts={sorts}
							isShowSlectionCount={false}
							additionalCountContent={{"text": "納品件数", "count": Registered.length}}
							hasSelections={true}
						/>
					</section>
				</article>
				<MainButtons buttons={mainButtons}/>
				<Footer/>
				{printDialogOpen &&
				<PdfViewer
					filePath={settings.pdfPath}
					afterCloseFunc={this.afterCloseFunc}
				/>
				}
				{printDialogModOpen &&
				<PdfViewer
					filePath={settings.pdfPathMod}
					afterCloseFunc={this.afterCloseModFunc}
				/>
				}
				{receiptPdfUrl &&
				<PdfViewer
					filePath={receiptPdfUrl}
					afterCloseFunc={this.afterCloseFuncReceiptSlips}
				/>
				}
				{printDialogSecomOpen &&
				<PdfViewer
					filePath={settings.pdfPathSecom}
					afterCloseFunc={this.afterCloseSecomFunc}
				/>
				}
				{printDialogArrivalOpen &&
				<PdfViewer
					filePath={settings.receiptArrivalPdfPath}
					afterCloseFunc={this.afterCloseArrivalFunc}
				/>
				}
				<AlertDialog
					open={dialogOpenUndo}
					title={"確認"}
					text={<span>選択された伝票の納品が取り消されます</span>}
					okFunction={this.doUndo}
					closeFunction={this.cancelUndo}
				/>
				<ErrorDialog
					open={showDlErrorDialog}
					title={'利用制限'}
					text={limitText}
					afterCloseFunc={this.handleCloseDlError}
				/>
				<ErrorDialog
					open={this.props.settings.isProcessError}
				/>
				<ReloadModal/>
				<LogoutModal/>
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		navigation: state.navigation,
		auth: state.auth,
		settings: state.receiptListSettings
	};
}

export default compose(
	withStyles(styles),
	connect(mapStateToProps)
)(ReceiptList);



// WEBPACK FOOTER //
// ./src/routes/receipt-list/index.js